import $ajax from 'axios'
import msgWarning from '@/tools/msgwarning.js'
import { Message } from 'element-ui'
import { showLoad, hideLoad } from "@/tools/loading.js";

export const mkUrl = 'https://www.jxcs.net/'
export const isGY = window.location.href.indexOf('jxgy') !== -1


// noLoading 不显示加载动画
// noSyncAlert 不进行-105弹窗
export default async (url, options) => {
  try {
    const defaultOption = {
      method: 'GET'
      // data: {}, // 用于 PUT POST 提交
      // timeout: 1000
    }
    options = Object.assign({}, defaultOption, options)
    let { data: res } = await $ajax({
      ...options,
      url
    })
    let { code, data, desc } = res
    if (code === '0') {
      // 成功
      return JSON.parse(data)
    } else if (code === '-101') {
      // throw {
      //   code,
      //   desc: JSON.parse(desc)
      // }
      dealCode101(url, JSON.parse(desc))
      return {
        errCode: '-101',
        data: JSON.parse(desc)
      }
    } else if (code === '-102') {
      // 活动价大于平台价
      dealCode102(url, JSON.parse(desc))
      return {
        errCode: '-102',
        data: JSON.parse(desc)
      }
    } else if (code === '-103') {
      // 结算价没有填写
      dealCode103(url, JSON.parse(desc))
      return 'err'
    } else if (code === '1') {
      Message({
        message: desc,
        type: 'warning',
        center: true
      })
      return 'warning'
      /* eslint-disable */
    } else if (code === '-1' && url.includes('GetTiktokCategoryValue')) {
      return res
    } else if (code === '-1' && url.includes('v2/sku/GetJdUpcCodeByName')) {
      // upc获取图片失败
      return ''
    } else if (code === '-1' && url.includes('v2/store/GetVendorStore')) {
      return desc
    }else if(code === '-1' && url.includes('v2/store/GetOrderID4Comment')){
      return desc
    }else if(code === '-1' && url.includes('v2/order/SelfDelivered')){
      return desc
    }
    /* eslint-disable-line */
    else if (code === '-105') {
      // 同步报错
      if (!options.noSyncAlert) dealCode105(url, desc)
      return {
        code: '-105',
        desc
      }
    }
    /* eslint-disable */
    else {
      hideLoad()
      throw desc
    }
   
  } catch (e) {
    hideLoad()
    throw e
  }
}


// 活动商品冲突报错
export function dealCode101(url, arr) {
  console.error('活动商品冲突', arr)
  let title = ''
  let thead = ''
  let tbody = ''
  if (url.indexOf('CreateAct') > -1 || url.indexOf('PreCreateAct') > -1) {
    title = '活动商品冲突'
    thead = `
      <tr>
        <th>活动ID</th>
        <th>门店ID</th>
        <th>skuID</th>
      </tr>
    `
    // let tbodyContent = ''
    arr.forEach(item => {
      tbody += `
        <tr>
          <td>${item.actID}</td>
          <td>${item.storeID}</td>
          <td>${item.skuID}</td>
        </tr>
      `
    })
  } else {
    title = '错误'
  }
  let html = `
    <table class="errmsg-table">
      <caption>${title}</caption>
      <thead>
        ${thead}
      </thead>
      <tbody>
        ${tbody}
      </tbody>
    </table>`
  msgWarning(html)
}


// 活动价不满足要求
export function dealCode102(url, arr) {
  console.error('活动价不满足要求', arr)
  let title = ''
  let thead = ''
  let tbody = ''
  if (url.indexOf('CreateAct') > -1 || url.indexOf('PreCreateAct') > -1 || url.indexOf('ForceUpdateVendorPrice') > -1) {
    title = '活动价不满足要求'
    thead = `
      <tr>
        <th>门店ID</th>
        <th>skuID</th>
        <th>京西价</th>
        <th>平台价</th>
        <th>活动价</th>
        <th>错误信息</th>
      </tr>
    `
    // let tbodyContent = ''
    arr.forEach(item => {
      tbody += `
        <tr>
          <td>${item.storeID}</td>
          <td>${item.skuID}</td>
          <td>${item.originalPrice / 100}</td>
          <td>${item.vendorPrice ? item.vendorPrice / 100 : 0}</td>
          <td>${item.actualActPrice ? item.actualActPrice / 100 : 0}</td>
          <td>${item.errMsg}</td>
        </tr>
      `
    })
  } else {
    title = '错误'
  }
  let html = `
    <table class="errmsg-table">
      <caption>${title}</caption>
      <thead>
        ${thead}
      </thead>
      <tbody>
        ${tbody}
      </tbody>
    </table>`
  msgWarning(html)
}


// 结算价未填写
export function dealCode103(url, arr) {
  console.error('结算价未填写', arr)
  let title = ''
  let thead = ''
  let tbody = ''
  if (url.indexOf('CreateAct') > -1 || url.indexOf('PreCreateAct') > -1) {
    title = '结算价未填写'
    thead = `
      <tr>
        <th>门店ID</th>
        <th>skuID</th>
        <th>京西价</th>
        <th>平台价</th>
        <th>活动价</th>
        <th>结算价</th>
      </tr>
    `
    // let tbodyContent = ''
    arr.forEach(item => {
      tbody += `
        <tr>
          <td>${item.storeID}</td>
          <td>${item.skuID}</td>
          <td>${item.originalPrice / 100}</td>
          <td>${item.vendorPrice ? item.vendorPrice / 100 : 0}</td>
          <td>${item.actPrice / 100}</td>
          <td>${item.earningPrice / 100}</td>
        </tr>
      `
    })
  } else {
    title = '错误'
  }
  let html = `
    <table class="errmsg-table">
      <caption>${title}</caption>
      <thead>
        ${thead}
      </thead>
      <tbody>
        ${tbody}
      </tbody>
    </table>`
  msgWarning(html)
}


export function dealCode105(url, str) {
  let title = ''
  let thead = ''
  let tbody = ''
  title = str.substring(0, str.indexOf('：'))
  let data = JSON.parse(str.substring(str.indexOf('：') + 1))
  thead += '<tr>'
  Object.keys(data[0]).forEach(item => {
    thead += `<th>${item}</th>`
  })
  thead += '</tr>'
  data.forEach(item => {
    tbody += '<tr>'
    for (let attr in item) {
      tbody += `<td>${item[attr]}</td>`
    }
    tbody += '</tr>'
  })
  let html = `
    <table class="errmsg-table">
      <caption>${title}</caption>
      <thead>
        ${thead}
      </thead>
      <tbody>
        ${tbody}
      </tbody>
    </table>`
  msgWarning(html, '同步失败', true)
}




// WEBPACK FOOTER //
// ./src/utils/api.js